import html2canvas from "html2canvas";

/**
 * Safe html2canvas wrapper that:
 * - supports cross-origin images
 * - avoids tainted canvas errors
 * - returns a Blob (required for upload or manual download)
 * - allows the caller to trigger download manually if needed
 */
export default function useStoryCard(storyRef) {
  return async function generateStoryCard() {
    if (!storyRef.current) {
      console.error("❌ StoryCard ref not found.");
      return null;
    }

    try {
      const canvas = await html2canvas(storyRef.current, {
        useCORS: true,
        allowTaint: false,
        backgroundColor: "#111827", // matches updated StoryCard
        scale: 2,
        width: 1080,
        height: 1920,
        logging: false,
      });

      // Convert canvas → Blob (safer than base64)
      const blob = await new Promise((resolve) =>
        canvas.toBlob((b) => resolve(b), "image/png", 1.0)
      );

      if (!blob) {
        console.error("❌ Failed to convert canvas to Blob.");
        return null;
      }

      return blob;
    } catch (err) {
      console.error("❌ Story card generation failed:", err);
      return null;
    }
  };
}
